import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import { withLocales, withClientConfig } from '@spotahome/bff/client';
import { localesShape } from '@spotahome/bff/shapes';
import { Modal, AccountNotValidatedBanner } from '@spotahome/ui-library';
import { Mediator } from '@spotahome/soyuz-mediator';
import { getLoggedInUserInfo } from '@spotahome/soyuz-auth-client';

import '@spotahome/ui-library/lib/components/Modal.css';
import '@spotahome/ui-library/lib/components/AccountNotValidatedBanner.css';
import './Header.scss';

import { resendActivationUser } from '../../client/common/api/traditional-login-client';

import DesktopHeader from './DesktopHeader';
import MobileHeader from './MobileHeader';

async function requestLoggedInUserInfo() {
  try {
    const response = await getLoggedInUserInfo();
    return response.data.email
      ? {
          email: response.data.email,
          verified: response.data.isActivatedByEmail,
          id: response.data.id
        }
      : null;
  } catch (err) {
    if (err.response && err.response.status === SESSION_EXPIRED_STATUS) {
      Mediator.publish(TOKEN_EXPIRED);
    } else {
      throw new Error(err);
    }
  }
}

function resendLink(id) {
  try {
    resendActivationUser(id);
  } catch (err) {
    console.log(err);
  }
}

class Header extends Component {
  state = {
    isMobileOpen: false
  };

  toggleMobileHeader = () => {
    this.setState({ isMobileOpen: !this.state.isMobileOpen });
  };

  render() {
    return (
      <Fragment>
        {this.props.clientConfig.featureToggle.traditionalLoginResendLink && (
          <AccountNotValidatedBanner
            getLoggedInUserInfo={requestLoggedInUserInfo}
            resendLinkCB={resendLink}
          />
        )}
        <header className="header">
          <DesktopHeader
            locales={this.props.locales}
            onClickMenu={this.toggleMobileHeader}
          />
          {this.state.isMobileOpen && (
            <Modal
              contentLabel="modal"
              size="fullscreen"
              isOpen={this.state.isMobileOpen}
            >
              <MobileHeader
                locales={this.props.locales}
                onClose={this.toggleMobileHeader}
              />
            </Modal>
          )}
        </header>
      </Fragment>
    );
  }
}

Header.propTypes = {
  locales: PropTypes.shape(localesShape).isRequired
};

export default withClientConfig()(withLocales()(Header));
